import { render, staticRenderFns } from "./IconScale.vue?vue&type=template&id=ba3c330e&scoped=true&"
import script from "./IconScale.vue?vue&type=script&lang=js&"
export * from "./IconScale.vue?vue&type=script&lang=js&"
import style0 from "./IconScale.vue?vue&type=style&index=0&id=ba3c330e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3c330e",
  null
  
)

export default component.exports